export const mangaData = [
  {
    id: 1,
    title: '星辰变',
    slug: 'xing-chen-bian',
    author: '我吃西红柿',
    cover: 'https://readdy.ai/api/search-image?query=A%20stunning%20Chinese%20manhua%20cover%20featuring%20a%20powerful%20cultivator%20with%20flowing%20long%20hair%20standing%20on%20a%20celestial%20mountain%20peak%2C%20surrounded%20by%20swirling%20starlight%20and%20energy%2C%20dramatic%20composition%2C%20vibrant%20warm%20colors%20with%20golden%20and%20crimson%20accents%2C%20clean%20minimal%20background%2C%20Japanese%20manga%20art%20style%20with%20soft%20shading%2C%20professional%20illustration&width=600&height=800&seq=manga-cover-01&orientation=portrait',
    category: '玄幻',
    status: '连载中',
    rating: 9.6,
    views: '1.2亿',
    updateTime: '今天 18:30',
    latestChapter: '第358话 星辰之力',
    description: '一部波澜壮阔的史诗级玄幻巨作。少年秦羽因无法修炼内功，被家族放弃，却凭借不屈的意志与机缘巧合，走上了一条前无古人的修炼之路。从凡人到星辰之主，他书写了一段属于自己传奇。',
    tags: ['热血', '玄幻', '修炼', '励志'],
    chapters: [
      { id: 358, title: '第358话 星辰之力', time: '今天 18:30' },
      { id: 357, title: '第357话 最后的决战', time: '昨天 20:15' },
      { id: 356, title: '第356话 破而后立', time: '前天 17:00' },
      { id: 355, title: '第355话 天劫降临', time: '3天前' },
      { id: 354, title: '第354话 生死一线', time: '4天前' },
      { id: 353, title: '第353话 突破瓶颈', time: '5天前' },
    ]
  },
  {
    id: 2,
    title: '绝世神医',
    slug: 'jue-shi-shen-yi',
    author: '花都大少',
    cover: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Chinese%20manhua%20cover%20of%20an%20elegant%20female%20doctor%20in%20traditional%20Chinese%20hanfu%20dress%20holding%20a%20golden%20needle%2C%20surrounded%20by%20floating%20cherry%20blossom%20petals%20and%20subtle%20green%20herbal%20elements%2C%20soft%20romantic%20atmosphere%2C%20clean%20minimal%20background%20with%20warm%20lighting%2C%20shoujo%20manga%20art%20style%2C%20delicate%20linework&width=600&height=800&seq=manga-cover-02&orientation=portrait',
    category: '古风',
    status: '连载中',
    rating: 9.4,
    views: '9800万',
    updateTime: '今天 12:00',
    latestChapter: '第203话 妙手回春',
    description: '现代女医生穿越到古代，凭借一身绝世医术悬壶济世。面对宫廷阴谋、江湖恩怨，她用智慧和医术化解危机，同时收获了一段刻骨铭心的爱情。医术超群，仁心济世。',
    tags: ['古风', '穿越', '医术', '爱情'],
    chapters: [
      { id: 203, title: '第203话 妙手回春', time: '今天 12:00' },
      { id: 202, title: '第202话 宫中惊变', time: '昨天 14:30' },
      { id: 201, title: '第201话 瘟疫蔓延', time: '前天 09:00' },
      { id: 200, title: '第200话 奇药现世', time: '3天前' },
      { id: 199, title: '第199话 深夜问诊', time: '4天前' },
      { id: 198, title: '第198话 王爷驾到', time: '5天前' },
    ]
  },
  {
    id: 3,
    title: '都市灵异录',
    slug: 'du-shi-ling-yi-lu',
    author: '夜不语',
    cover: 'https://readdy.ai/api/search-image?query=A%20mysterious%20dark%20Chinese%20manhua%20cover%20showing%20a%20young%20man%20in%20modern%20city%20clothing%20holding%20a%20glowing%20talisman%20in%20a%20foggy%20urban%20alleyway%20at%20night%2C%20ghostly%20figures%20lurking%20in%20shadows%2C%20moody%20atmospheric%20lighting%20with%20cool%20and%20warm%20contrast%2C%20clean%20composition%2C%20modern%20horror%20manga%20art%20style%2C%20detailed%20background&width=600&height=800&seq=manga-cover-03&orientation=portrait',
    category: '悬疑',
    status: '连载中',
    rating: 9.2,
    views: '7600万',
    updateTime: '昨天 22:00',
    latestChapter: '第167话 午夜来电',
    description: '平凡大学生林墨意外开启了阴阳眼，从此能看见常人无法看见的东西。城市的阴影中隐藏着无数诡异事件，他必须在真相和危险之间找到平衡。',
    tags: ['悬疑', '都市', '灵异', '惊悚'],
    chapters: [
      { id: 167, title: '第167话 午夜来电', time: '昨天 22:00' },
      { id: 166, title: '第166话 废弃医院', time: '2天前' },
      { id: 165, title: '第165话 鬼打墙', time: '3天前' },
      { id: 164, title: '第164话 红衣女子', time: '4天前' },
      { id: 163, title: '第163话 电梯惊魂', time: '5天前' },
      { id: 162, title: '第162话 镜中世界', time: '6天前' },
    ]
  },
  {
    id: 4,
    title: '美食大冒险',
    slug: 'mei-shi-da-mao-xian',
    author: '吃货小当家',
    cover: 'https://readdy.ai/api/search-image?query=A%20delightful%20Chinese%20manhua%20cover%20featuring%20a%20cheerful%20young%20chef%20in%20apron%20holding%20a%20steaming%20bowl%20of%20ramen%20with%20exaggerated%20expressions%2C%20colorful%20food%20illustrations%20floating%20around%2C%20bright%20warm%20colors%2C%20clean%20minimal%20background%2C%20playful%20manga%20art%20style%20with%20bold%20lines%2C%20mouthwatering%20food%20rendering&width=600&height=800&seq=manga-cover-04&orientation=portrait',
    category: '搞笑',
    status: '连载中',
    rating: 9.1,
    views: '6500万',
    updateTime: '今天 08:00',
    latestChapter: '第125话 厨神争霸',
    description: '拥有超强味觉的少年苏小凡，立志成为世界第一厨师。从街头小摊到米其林餐厅，他用美食征服了无数人的味蕾，也收获了一群志同道合的伙伴。',
    tags: ['搞笑', '美食', '热血', '日常'],
    chapters: [
      { id: 125, title: '第125话 厨神争霸', time: '今天 08:00' },
      { id: 124, title: '第124话 神秘食材', time: '昨天 10:00' },
      { id: 123, title: '第123话 夜市挑战', time: '前天 16:00' },
      { id: 122, title: '第122话 刀工对决', time: '3天前' },
      { id: 121, title: '第121话 甜品大师', time: '4天前' },
      { id: 120, title: '第120话 火锅盛宴', time: '5天前' },
    ]
  },
  {
    id: 5,
    title: '龙族传说',
    slug: 'long-zu-chuan-shuo',
    author: '江南烟雨',
    cover: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20manhua%20cover%20showing%20a%20majestic%20golden%20dragon%20coiled%20around%20an%20ancient%20pagoda%20in%20clouds%2C%20a%20young%20warrior%20with%20sword%20facing%20the%20dragon%2C%20dramatic%20sunset%20sky%20with%20warm%20golden%20and%20orange%20hues%2C%20traditional%20Chinese%20fantasy%20art%20style%2C%20clean%20composition%2C%20epic%20scale%2C%20intricate%20details&width=600&height=800&seq=manga-cover-05&orientation=portrait',
    category: '玄幻',
    status: '连载中',
    rating: 9.5,
    views: '1.5亿',
    updateTime: '今天 20:00',
    latestChapter: '第412话 龙神觉醒',
    description: '远古龙族后裔在现代世界苏醒，少年龙宇在命运的指引下踏上寻根之旅。龙族、人类、神魔三界的平衡即将被打破，他能否成为传说中的龙神？',
    tags: ['玄幻', '冒险', '热血', '龙族'],
    chapters: [
      { id: 412, title: '第412话 龙神觉醒', time: '今天 20:00' },
      { id: 411, title: '第411话 龙谷秘境', time: '昨天 19:00' },
      { id: 410, title: '第410话 上古遗迹', time: '前天 21:00' },
      { id: 409, title: '第409话 血脉觉醒', time: '3天前' },
      { id: 408, title: '第408话 龙族试炼', time: '4天前' },
      { id: 407, title: '第407话 宿命对决', time: '5天前' },
    ]
  },
  {
    id: 6,
    title: '校园日记',
    slug: 'xiao-yuan-ri-ji',
    author: '青涩年华',
    cover: 'https://readdy.ai/api/search-image?query=A%20heartwarming%20Chinese%20manhua%20cover%20of%20two%20high%20school%20students%20a%20boy%20and%20a%20girl%20walking%20under%20cherry%20blossom%20trees%20in%20spring%2C%20school%20uniforms%2C%20backpacks%2C%20gentle%20sunlight%20filtering%20through%20petals%2C%20soft%20pastel%20colors%2C%20clean%20minimal%20background%2C%20youthful%20romantic%20atmosphere%2C%20shoujo%20manga%20style&width=600&height=800&seq=manga-cover-06&orientation=portrait',
    category: '恋爱',
    status: '已完结',
    rating: 9.3,
    views: '8900万',
    updateTime: '3天前',
    latestChapter: '第180话 毕业季（终）',
    description: '高一新生林小雨和学霸同桌陆子昂之间的青春故事。从互不相识到相知相守，三年高中时光，有欢笑有泪水，记录着最纯真的校园爱情。',
    tags: ['恋爱', '校园', '青春', '治愈'],
    chapters: [
      { id: 180, title: '第180话 毕业季（终）', time: '3天前' },
      { id: 179, title: '第179话 告白', time: '4天前' },
      { id: 178, title: '第178话 樱花树下', time: '5天前' },
      { id: 177, title: '第177话 学园祭', time: '6天前' },
      { id: 176, title: '第176话 雨中的约定', time: '7天前' },
      { id: 175, title: '第175话 误会', time: '8天前' },
    ]
  },
  {
    id: 7,
    title: '剑道至尊',
    slug: 'jian-dao-zhi-zun',
    author: '一剑封喉',
    cover: 'https://readdy.ai/api/search-image?query=A%20dynamic%20Chinese%20manhua%20cover%20of%20a%20swordsman%20in%20flowing%20white%20robes%20wielding%20a%20gleaming%20sword%20atop%20a%20misty%20mountain%2C%20sword%20energy%20waves%20rippling%20outward%2C%20dramatic%20wind%20effects%2C%20clean%20minimal%20background%20with%20soft%20blue-grey%20mist%2C%20wuxia%20art%20style%2C%20powerful%20composition&width=600&height=800&seq=manga-cover-07&orientation=portrait',
    category: '武侠',
    status: '连载中',
    rating: 9.7,
    views: '1.8亿',
    updateTime: '今天 16:00',
    latestChapter: '第289话 剑破苍穹',
    description: '江湖第一剑客叶无尘遭人暗算，重生回到少年时期。带着前世的记忆和剑道感悟，他誓要改写命运，登顶剑道巅峰，成为万剑至尊。',
    tags: ['武侠', '重生', '剑道', '热血'],
    chapters: [
      { id: 289, title: '第289话 剑破苍穹', time: '今天 16:00' },
      { id: 288, title: '第288话 天外飞仙', time: '昨天 15:00' },
      { id: 287, title: '第287话 剑意化形', time: '前天 18:00' },
      { id: 286, title: '第286话 生死剑', time: '3天前' },
      { id: 285, title: '第285话 剑冢试炼', time: '4天前' },
      { id: 284, title: '第284话 万剑归宗', time: '5天前' },
    ]
  },
  {
    id: 8,
    title: '星际猎人',
    slug: 'xing-ji-lie-ren',
    author: '星海游侠',
    cover: 'https://readdy.ai/api/search-image?query=A%20futuristic%20Chinese%20manhua%20cover%20showing%20a%20cool%20bounty%20hunter%20in%20sci-fi%20armor%20holding%20a%20plasma%20rifle%20in%20a%20neon-lit%20space%20station%2C%20stars%20visible%20through%20window%2C%20cyberpunk%20aesthetic%2C%20clean%20composition%2C%20vibrant%20neon%20accents%2C%20modern%20sci-fi%20manga%20art%20style%2C%20dynamic%20pose&width=600&height=800&seq=manga-cover-08&orientation=portrait',
    category: '科幻',
    status: '连载中',
    rating: 9.0,
    views: '5400万',
    updateTime: '昨天 23:00',
    latestChapter: '第98话 黑洞边缘',
    description: '公元2580年，人类已遍布银河系。赏金猎人雷诺在一次追捕任务中，意外发现了一个足以颠覆整个银河秩序的秘密。星际冒险就此展开。',
    tags: ['科幻', '冒险', '机甲', '热血'],
    chapters: [
      { id: 98, title: '第98话 黑洞边缘', time: '昨天 23:00' },
      { id: 97, title: '第97话 星际海盗', time: '2天前' },
      { id: 96, title: '第96话 异星遗迹', time: '3天前' },
      { id: 95, title: '第95话 空间跳跃', time: '4天前' },
      { id: 94, title: '第94话 机械叛乱', time: '5天前' },
      { id: 93, title: '第93话 暗影组织', time: '6天前' },
    ]
  },
  {
    id: 9,
    title: '萌宠日记',
    slug: 'meng-chong-ri-ji',
    author: '毛茸茸',
    cover: 'https://readdy.ai/api/search-image?query=A%20cute%20Chinese%20manhua%20cover%20featuring%20a%20young%20girl%20happily%20surrounded%20by%20various%20adorable%20pets%20a%20fluffy%20cat%20a%20small%20dog%20and%20a%20rabbit%20in%20a%20cozy%20room%2C%20warm%20soft%20colors%2C%20clean%20minimal%20background%2C%20kawaii%20manga%20art%20style%2C%20gentle%20lighting%2C%20wholesome%20atmosphere&width=600&height=800&seq=manga-cover-09&orientation=portrait',
    category: '日常',
    status: '连载中',
    rating: 8.9,
    views: '4200万',
    updateTime: '今天 10:00',
    latestChapter: '第72话 新成员',
    description: '动物爱好者小萌收养了一只会说话的神秘猫咪后，生活变得热闹非凡。每天与各种萌宠相处的温馨日常，治愈你的每一天。',
    tags: ['日常', '治愈', '宠物', '搞笑'],
    chapters: [
      { id: 72, title: '第72话 新成员', time: '今天 10:00' },
      { id: 71, title: '第71话 猫咪咖啡厅', time: '昨天 11:00' },
      { id: 70, title: '第70话 流浪动物救助', time: '前天 13:00' },
      { id: 69, title: '第69话 宠物运动会', time: '3天前' },
      { id: 68, title: '第68话 洗澡大作战', time: '4天前' },
      { id: 67, title: '第67话 深夜探险', time: '5天前' },
    ]
  },
  {
    id: 10,
    title: '异能少年团',
    slug: 'yi-neng-shao-nian-tuan',
    author: '超级英雄迷',
    cover: 'https://readdy.ai/api/search-image?query=A%20vibrant%20Chinese%20manhua%20cover%20of%20five%20teenagers%20each%20with%20different%20superpowers%20fire%20ice%20lightning%20telepathy%20super%20strength%20standing%20together%20in%20heroic%20poses%20against%20a%20city%20skyline%2C%20dynamic%20action%20composition%2C%20bright%20bold%20colors%2C%20clean%20minimal%20background%2C%20shonen%20manga%20art%20style&width=600&height=800&seq=manga-cover-10&orientation=portrait',
    category: '热血',
    status: '连载中',
    rating: 9.3,
    views: '1.1亿',
    updateTime: '今天 14:00',
    latestChapter: '第215话 终极对决',
    description: '五个拥有不同超能力的高中生被秘密组织招募，组成异能少年团。他们一边应对校园生活，一边与邪恶势力战斗，守护城市和平。',
    tags: ['热血', '超能力', '校园', '战斗'],
    chapters: [
      { id: 215, title: '第215话 终极对决', time: '今天 14:00' },
      { id: 214, title: '第214话 能力觉醒', time: '昨天 16:00' },
      { id: 213, title: '第213话 秘密基地', time: '前天 11:00' },
      { id: 212, title: '第212话 新敌人', time: '3天前' },
      { id: 211, title: '第211话 团队分裂', time: '4天前' },
      { id: 210, title: '第210话 信任危机', time: '5天前' },
    ]
  },
  {
    id: 11,
    title: '冥界判官',
    slug: 'ming-jie-pan-guan',
    author: '幽冥使者',
    cover: 'https://readdy.ai/api/search-image?query=A%20dark%20atmospheric%20Chinese%20manhua%20cover%20of%20a%20mysterious%20judge%20in%20traditional%20black%20and%20red%20robes%20holding%20a%20roll%20of%20judgment%20scroll%20in%20a%20gothic%20underworld%20courtroom%2C%20ghostly%20flames%20flickering%2C%20moody%20dramatic%20lighting%2C%20clean%20composition%2C%20dark%20fantasy%20manga%20art%20style&width=600&height=800&seq=manga-cover-11&orientation=portrait',
    category: '悬疑',
    status: '连载中',
    rating: 9.1,
    views: '5800万',
    updateTime: '昨天 21:00',
    latestChapter: '第143话 生死簿',
    description: '普通上班族周明意外死亡后成为了冥界判官，负责审判亡魂的善恶。在阴阳两界穿梭的过程中，他发现了冥界不为人知的惊天秘密。',
    tags: ['悬疑', '奇幻', '冥界', '推理'],
    chapters: [
      { id: 143, title: '第143话 生死簿', time: '昨天 21:00' },
      { id: 142, title: '第142话 枉死城', time: '2天前' },
      { id: 141, title: '第141话 奈何桥', time: '3天前' },
      { id: 140, title: '第140话 十八层地狱', time: '4天前' },
      { id: 139, title: '第139话 黑白无常', time: '5天前' },
      { id: 138, title: '第138话 阎王殿', time: '6天前' },
    ]
  },
  {
    id: 12,
    title: '武道狂徒',
    slug: 'wu-dao-kuang-tu',
    author: '铁拳无敌',
    cover: 'https://readdy.ai/api/search-image?query=An%20intense%20Chinese%20manhua%20cover%20of%20a%20muscular%20fighter%20in%20torn%20martial%20arts%20uniform%20with%20fists%20wrapped%20in%20bandages%20standing%20in%20a%20destroyed%20arena%2C%20dust%20and%20debris%20floating%2C%20dramatic%20lighting%20from%20above%2C%20clean%20composition%2C%20gritty%20fighting%20manga%20art%20style%2C%20powerful%20muscular%20anatomy&width=600&height=800&seq=manga-cover-12&orientation=portrait',
    category: '热血',
    status: '连载中',
    rating: 9.4,
    views: '9200万',
    updateTime: '今天 19:00',
    latestChapter: '第267话 武神降临',
    description: '从贫民窟走出的少年林峰，凭借一双铁拳在武道世界打出名堂。地下格斗场的血腥洗礼，让他一步步接近武道巅峰。热血沸腾的格斗盛宴！',
    tags: ['热血', '格斗', '竞技', '励志'],
    chapters: [
      { id: 267, title: '第267话 武神降临', time: '今天 19:00' },
      { id: 266, title: '第266话 地狱特训', time: '昨天 17:00' },
      { id: 265, title: '第265话 冠军之战', time: '前天 14:00' },
      { id: 264, title: '第264话 禁术对决', time: '3天前' },
      { id: 263, title: '第263话 兄弟反目', time: '4天前' },
      { id: 262, title: '第262话 擂台风云', time: '5天前' },
    ]
  },
];

export const categories = [
  { name: '全部', slug: 'all', icon: 'ri-grid-line' },
  { name: '玄幻', slug: 'xuan-huan', icon: 'ri-magic-line' },
  { name: '武侠', slug: 'wu-xia', icon: 'ri-sword-line' },
  { name: '古风', slug: 'gu-feng', icon: 'ri-building-4-line' },
  { name: '恋爱', slug: 'lian-ai', icon: 'ri-heart-line' },
  { name: '悬疑', slug: 'xuan-yi', icon: 'ri-search-eye-line' },
  { name: '科幻', slug: 'ke-huan', icon: 'ri-rocket-line' },
  { name: '热血', slug: 're-xue', icon: 'ri-fire-line' },
  { name: '搞笑', slug: 'gao-xiao', icon: 'ri-emotion-laugh-line' },
  { name: '日常', slug: 'ri-chang', icon: 'ri-sun-line' },
];

export const rankings = [
  { rank: 1, mangaId: 7, trend: 'up', change: 0 },
  { rank: 2, mangaId: 1, trend: 'up', change: 1 },
  { rank: 3, mangaId: 5, trend: 'down', change: -1 },
  { rank: 4, mangaId: 12, trend: 'up', change: 2 },
  { rank: 5, mangaId: 2, trend: 'stable', change: 0 },
  { rank: 6, mangaId: 10, trend: 'up', change: 3 },
  { rank: 7, mangaId: 6, trend: 'down', change: -1 },
  { rank: 8, mangaId: 3, trend: 'stable', change: 0 },
  { rank: 9, mangaId: 11, trend: 'up', change: 1 },
  { rank: 10, mangaId: 4, trend: 'down', change: -2 },
];

export const banners = [
  {
    id: 1,
    title: '剑道至尊',
    subtitle: '万剑归宗，剑破苍穹！年度最燃武侠巨作',
    mangaId: 7,
    image: 'https://readdy.ai/api/search-image?query=A%20breathtaking%20Chinese%20martial%20arts%20scene%20of%20a%20lone%20swordsman%20standing%20on%20a%20misty%20mountain%20peak%20at%20dawn%2C%20thousands%20of%20swords%20floating%20in%20the%20air%20surrounding%20him%2C%20golden%20sunrise%20light%2C%20ethereal%20atmosphere%2C%20soft%20pastel%20pink%20and%20warm%20golden%20tones%2C%20clean%20composition%2C%20epic%20cinematic%20style&width=1600&height=700&seq=banner-01&orientation=landscape',
    color: 'from-accent-900/60 to-primary-900/40',
  },
  {
    id: 2,
    title: '星辰变',
    subtitle: '从凡人到星辰之主，不朽传奇等你见证',
    mangaId: 1,
    image: 'https://readdy.ai/api/search-image?query=A%20magnificent%20cosmic%20fantasy%20scene%20with%20a%20figure%20floating%20among%20stars%20and%20nebula%20clouds%2C%20galaxies%20spiraling%20in%20the%20background%2C%20ethereal%20starlight%20illuminating%20the%20scene%2C%20soft%20pastel%20pink%20and%20deep%20indigo%20color%20palette%2C%20dreamy%20atmosphere%2C%20clean%20composition&width=1600&height=700&seq=banner-02&orientation=landscape',
    color: 'from-primary-900/60 to-background-950/40',
  },
  {
    id: 3,
    title: '异能少年团',
    subtitle: '五大超能力者集结，守护城市和平',
    mangaId: 10,
    image: 'https://readdy.ai/api/search-image?query=A%20dynamic%20urban%20superhero%20scene%20with%20five%20silhouetted%20teenagers%20displaying%20different%20elemental%20powers%20fire%20ice%20lightning%20wind%20on%20a%20rooftop%20overlooking%20a%20futuristic%20city%20at%20sunset%2C%20warm%20golden%20and%20coral%20sky%2C%20cinematic%20composition%2C%20clean%20aesthetic&width=1600&height=700&seq=banner-03&orientation=landscape',
    color: 'from-accent-900/50 to-secondary-900/40',
  },
];

export const faqData = [
  {
    question: '樱花漫画是完全免费的吗？',
    answer: '是的！樱花漫画所有内容完全免费，无需充值会员即可畅读全部漫画。我们致力于为广大漫画爱好者提供优质的免费阅读体验。',
  },
  {
    question: '如何找到我想看的漫画？',
    answer: '您可以通过首页的分类导航浏览不同类型漫画，也可以使用搜索功能直接查找漫画名称。我们还会在首页推荐热门和最新更新的漫画供您发现。',
  },
  {
    question: '漫画多长时间更新一次？',
    answer: '大部分热门漫画每日更新，部分作品根据作者更新进度可能隔天更新。您可以将喜欢的漫画加入收藏，更新时会第一时间通知您。',
  },
  {
    question: '阅读记录会保存吗？',
    answer: '会的！系统会自动记录您的阅读进度，下次打开同一部漫画时会自动跳转到上次阅读的章节，无需手动翻找。',
  },
  {
    question: '支持手机端阅读吗？',
    answer: '樱花漫画完美适配手机、平板和电脑，采用下拉式阅读模式，在手机上也能获得流畅舒适的阅读体验。',
  },
];

export const aboutInfo = {
  brandIntro: '樱花漫画成立于2020年，是国内领先的免费漫画在线阅读平台。我们致力于为漫画爱好者提供丰富、优质、免费的漫画资源，打造极致的阅读体验。平台现已收录超过10万部各类漫画作品，涵盖玄幻、武侠、恋爱、悬疑、科幻等二十余个分类，每日更新数百话内容。',
  mission: '樱花漫画的使命是"让每个人都能轻松享受漫画的乐趣"。我们相信，好的漫画作品应该被更多人看到。因此，我们坚持免费模式，同时确保内容质量和阅读体验。',
  stats: [
    { label: '收录漫画', value: '100,000+' },
    { label: '每日更新', value: '500+' },
    { label: '注册用户', value: '3,000万+' },
    { label: '月活跃用户', value: '1,200万+' },
  ],
  testimonials: [
    { name: '漫画迷小王', avatar: 'https://readdy.ai/api/search-image?query=A%20friendly%20young%20Chinese%20man%20avatar%20portrait%20with%20warm%20smile%2C%20simple%20clean%20background%2C%20soft%20lighting%2C%20professional%20headshot%20style&width=100&height=100&seq=avatar-01&orientation=squarish', text: '用了樱花漫画三年了，资源真的很全！更新速度也快，强烈推荐给所有漫画爱好者！' },
    { name: '追更达人小李', avatar: 'https://readdy.ai/api/search-image?query=A%20cheerful%20Chinese%20young%20woman%20avatar%20portrait%20with%20bright%20smile%2C%20simple%20clean%20background%2C%20soft%20natural%20lighting%2C%20professional%20headshot%20style&width=100&height=100&seq=avatar-02&orientation=squarish', text: '下拉式阅读真的太方便了！在地铁上也能轻松追更，画面清晰流畅，体验满分！' },
    { name: '资深漫迷老张', avatar: 'https://readdy.ai/api/search-image?query=A%20mature%20Chinese%20man%20avatar%20portrait%20with%20friendly%20expression%2C%20simple%20clean%20background%2C%20soft%20warm%20lighting%2C%20professional%20headshot%20style&width=100&height=100&seq=avatar-03&orientation=squarish', text: '作为一个看了二十年漫画的老漫迷，樱花漫画的收录量和更新速度真的没话说。免费又良心！' },
  ],
  contact: {
    email: 'support@sakuramanga.example.com',
    wechat: 'sakuramanga_official',
    qq: '1234567890',
    address: '北京市朝阳区樱花路88号',
  },
};